import { Outlet } from "react-router-dom";

const Base = () => {
    return <Outlet />;
};

export default Base;
